import {InstrumentFactories} from "@opendaw/studio-adapters"
import {UUID} from "@opendaw/lib-std"

export const DefaultPlayfieldAttachment: InstrumentFactories.PlayfieldAttachment = [
    {
        note: 60,
        uuid: UUID.parse("8bb2c6e8-9a6d-4d32-b7ec-1263594ef367"),
        name: "909 Bassdrum",
        durationInSeconds: 0.509,
        exclude: false
    },
    {
        note: 61,
        uuid: UUID.parse("0017fa18-a5eb-4d9d-b6f2-e2ddd30a3010"),
        name: "909 Snare",
        durationInSeconds: 0.235,
        exclude: false
    },
    {
        note: 62,
        uuid: UUID.parse("28d14cb9-1dc6-4193-9dd7-4e881f25f520"),
        name: "909 Low Tom",
        durationInSeconds: 0.509,
        exclude: false
    },
    {
        note: 63,
        uuid: UUID.parse("21f92306-d6e7-446c-a34b-b79620acfefc"),
        name: "909 Mid Tom",
        durationInSeconds: 0.385,
        exclude: false
    },
    {
        note: 64,
        uuid: UUID.parse("ad503883-8a72-46ab-a05b-a84149953e17"),
        name: "909 High Tom",
        durationInSeconds: 0.511,
        exclude: false
    },
    {
        note: 65,
        uuid: UUID.parse("cfee850b-7658-4d08-9e3b-79d196188504"),
        name: "909 Rimshot",
        durationInSeconds: 0.150,
        exclude: false
    },
    {
        note: 66,
        uuid: UUID.parse("32a6f36f-06eb-4b84-bb57-5f51103eb9e6"),
        name: "909 Clap",
        durationInSeconds: 0.507,
        exclude: false
    },
    {
        note: 67,
        uuid: UUID.parse("e0ac4b39-23fb-4a56-841d-c9e0ff440cab"),
        name: "909 Closed Hat",
        durationInSeconds: 0.154,
        exclude: true
    },
    {
        note: 68,
        uuid: UUID.parse("51c5eea4-391c-4743-896a-859692ec1105"),
        name: "909 Open Hat",
        durationInSeconds: 0.502,
        exclude: true
    },
    {
        note: 69,
        uuid: UUID.parse("42a56ff6-89b6-4f2e-8a66-5a41d316f4cb"),
        name: "909 Crash",
        durationInSeconds: 1.055,
        exclude: false
    },
    {
        note: 70,
        uuid: UUID.parse("87cde966-b799-4efc-a994-069e703478d3"),
        name: "909 Ride",
        durationInSeconds: 1.720,
        exclude: false
    }
]